import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class NoticiaProvider {
  baseUrl = environment.API_URL;
  total: any = 0;
  constructor(public http: HttpClient) {}

  getTotalNaoLidas() {
    return this.total;
  }

  getInicioNoticias() {
    return this.http.get<any>(this.baseUrl + '/noticia/get-nao-lidas', {}).map((data) => {
      if (!data.error) {
        this.total = data;
        return data;
      } else {
        return false;
      }
    });
  }

  getNoticias(categoria) {
    return this.http
      .post<any>(this.baseUrl + '/noticia/get-noticias-v2', {
        categoria: categoria,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getNoticiaById(id) {
    return this.http.post<any>(this.baseUrl + '/noticia/get-noticia', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getNoticiaByIdExterno(id) {
    return this.http
      .get<any>(this.baseUrl + '/noticia-externo/get-noticia', {
        params: { id: id },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getNoticiasFavoritas() {
    return this.http.post<any>(this.baseUrl + '/noticia/get-noticias-favoritas', {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getNoticiasDetaques() {
    let filtro: any = {};
    filtro.destaque = '1';
    return this.http.post<any>(this.baseUrl + '/noticia/get-noticias', { filtro: filtro }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getCategorias(categorias) {
    return this.http
      .post<any>(this.baseUrl + '/noticia/get-categorias-v2', {
        filtro: categorias,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getCategoria(idCategoria) {
    return this.http
      .post<any>(this.baseUrl + '/noticia/get-categoria', {
        idCategoria: idCategoria,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  setFavoritos(idNoticia) {
    return this.http
      .post<any>(this.baseUrl + '/noticia/set-favorito', {
        idNoticia: idNoticia,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/noticia/noticia.ts